import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import moment from 'moment';
import LandmanBillExceptionHistory from 'src/models/personnel/LandmanBillExceptionHistory';

interface IBillExceptionHistoryDialogProps {
    dialogName: string;
    defaultBillHistory: Array<LandmanBillExceptionHistory>;
    hideDialog: () => void;
}

const BillExceptionHistoryDialog = (props: IBillExceptionHistoryDialogProps) => {
    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('BillExceptionHistoryDialog onCreate()', props.defaultBillHistory);
    };

    const OKClicked = () => {
        props.hideDialog();
    };

    const getPayByValue = (value: string) => {
        switch (value) {
            case 'D':
                return 'Day';
            case 'H':
                return 'Hour';
            case 'M':
                return 'Month';
            default:
                return 'Unknown';
        }
    };

    return (
        <Dialog title="Bill Exception History" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ maxHeight: '75%', width: '65%' }}>
            {props.defaultBillHistory?.length > 0 && <div>
                <div style={{ overflowY: 'scroll', maxHeight: '25rem' }}>
                    <table style={{ width: '100%' }}>
                        <thead>
                            <tr style={{ background: '#d6d6d6' }}>
                                <th style={{ width: '10%' }}>Pay By</th>
                                <th style={{ width: '10%' }}>Pay Rate</th>
                                <th style={{ width: '15%' }}>Eff Date</th>
                                <th style={{ width: '10%' }}>Manager</th>
                                <th style={{ width: '25%' }}>Manager Name</th>
                                <th style={{ width: '10%' }}>Prod. Bonus</th>
                                <th style={{ width: '10%' }}>Prev Pay By</th>
                                <th style={{ width: '10%' }}>Prev Pay Rate</th>
                            </tr>
                        </thead>
                        {props.defaultBillHistory?.map((pay: LandmanBillExceptionHistory, index: number) => {
                            return (
                                <tbody key={index}>
                                    <tr className={`contract-pay-history-active-item-${index}`}>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {getPayByValue(pay.billUnit)}
                                        </td>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {parseFloat(pay.billRate?.toString()).toFixed(2)}
                                        </td>
                                        <td style={{ width: '15%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {moment(pay.chgDate).format('YYYY-MM-DD') as unknown as Date}
                                        </td>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            TBD
                                        </td>
                                        <td style={{ width: '25%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {pay.tsdUser}
                                        </td>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            ?
                                        </td>
                                        <td style={{ width: '10%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {getPayByValue(pay.prevUnit)}
                                        </td>
                                        <td style={{ width: '15%', border: '1px solid black', borderCollapse: 'collapse' }}>
                                            {parseFloat(pay.prevRate?.toString()).toFixed(2)}
                                        </td>
                                    </tr>
                                </tbody>
                            );
                        })}
                    </table>
                </div>
            </div>}
            {props.defaultBillHistory?.length <= 0 && <div className="bold-centered">No Pay Exceptions for Project</div>}
            <div className="form-row" style={{ marginTop: '2rem', justifyContent: 'center', textAlign: 'center' }}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Close'}
                    onClick={() => OKClicked()}
                />
            </div>
        </Dialog>
    );
};

export default BillExceptionHistoryDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/pay/BillingExceptionHistoryDialog.tsx